import React from 'react';
import { connect } from 'react-redux';
import { cloneDeep, sortBy } from 'lodash';
import { getTenantState, getAdminState } from '../../store/selectors';
import FuzzySearchBar from '../career-search/FuzzySearchBar';
import Loading from '../utility/Loading';
import { usersCopy } from '../../copy/advisor-dashboard/advisor-dashboard-base.json';
import { updateUsersTabFilters } from '../../store/actions';

export class FilterSection extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      options: [],
      loading: true,
    };
  }

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  componentDidMount = () => {
    this._isMounted = true;
    if (this._isMounted) {
      this.setState({
        options: this.props.admin.permissions.usersFilters[this.props.listName],
        loading: false,
      });
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  displayFilterOptions = (option) => {
    const valueInProps = this.filterOptions.filter(
      (x) => x.titleEn === option.titleEn
    );
    return (
      <div className="filters-section__checkbox-and-label" key={option.titleEn}>
        <input
          type="checkbox"
          className="filters-section__checkbox"
          style={this.colorPrimary}
          id={option.titleEn}
          onChange={() => {
            this.handleCheckbox(this.filterOptions, option);
          }}
          checked={valueInProps[0]?.checked}
        />
        <label
          htmlFor={option.titleEn}
          className="filters-section__checkbox-label"
        >
          {option.titleEn}
        </label>
      </div>
    );
  };

  setFilteredOptionsList = (result) => {
    if (this._isMounted) {
      this.setState({
        options: result,
      });
    }
  };

  setOptionsLoading = (bool) => {
    if (this._isMounted) {
      this.setState({
        loading: bool,
      });
    }
  };

  get filterOptions() {
    return this.props.filterOptions;
  }

  handleCheckbox = (list, checkedValue) => {
    const index = list.findIndex((obj) => obj.titleEn === checkedValue.titleEn);
    const listToUpdate = cloneDeep(list);
    listToUpdate[index].checked = !listToUpdate[index].checked;
    const filters = this.props.admin.permissions.usersFilters;
    filters[this.props.listName] = listToUpdate;
    this.props.updateUsersTabFilters(filters);
  };

  get determineSelectOrDeselectAll() {
    const { filterOptions } = this.props;
    const checked = filterOptions.find((o) => o.checked === false);
    return checked === undefined
      ? usersCopy.deselectText
      : usersCopy.selectText;
  }

  selectOrDeselectAll = () => {
    const { listName } = this.props;
    const bool = this.determineSelectOrDeselectAll === usersCopy.selectText;
    const filters = cloneDeep(this.props.admin.permissions.usersFilters);
    filters[listName] = [];
    this.props.admin.permissions.usersFilters[listName].forEach((o) => {
      filters[listName].push({
        ...o,
        checked: bool,
      });
    });
    this.props.updateUsersTabFilters(filters);
  };

  render() {
    const sortedOptions = sortBy(this.state.options, ['titleEn']);
    return (
      <div className="filters-section">
        <div className="filters-section__header">
          <div className="filters-section__row">
            <p>{this.props.filterTitle}</p>
            <button
              type="button"
              className="filters-section__select-all"
              style={this.colorPrimary}
              onClick={() => {
                this.selectOrDeselectAll();
              }}
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key)) this.selectOrDeselectAll();
              }}
            >
              {this.determineSelectOrDeselectAll}
            </button>
          </div>
          <FuzzySearchBar
            inputText="Search"
            tenant={this.props.tenant}
            listToSearch={this.filterOptions}
            sendFilteredListToParent={this.setFilteredOptionsList}
            setSearchListLoadingOnParent={this.setOptionsLoading}
            overRideStylesMag="--career-search-only"
          />
        </div>
        <div
          className={
            this.state.loading
              ? 'filters-section__for-loading-spinner filters-section__scrollable-filters'
              : 'filters-section__scrollable-filters'
          }
        >
          {this.state.loading && <Loading height="100%" />}
          {!this.state.loading &&
            sortedOptions.map((option, index) =>
              this.displayFilterOptions(option, index)
            )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  const admin = getAdminState(state);
  return { tenant, admin };
}

export default connect(mapStateToProps, {
  updateUsersTabFilters,
})(FilterSection);
